"use client";

import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useCart } from "./cartContext";


export default function CategoryProductCards () {
    const { id } = useParams(); // Get category ID from URL
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { updateCartCount } = useCart();
    const userId = Cookies.get("userId");

    useEffect(() => {
        const fetchProductsByCategory = async () => {
            try {
                setIsLoading(true);

                // Create FormData and append the category_id
                const formData = new FormData();
                formData.append('category_id', id);

                const response = await fetch(
                    'https://leapatinternational.com/admin/api/v1/web_get_products_by_category.php',
                    {
                        method: 'POST',
                        body: formData,
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();

                if (result.success || result.status === 'success') {
                    setProducts(result.data || []);
                } else {
                    throw new Error(result.message || 'Failed to fetch products');
                }
            } catch (error) {
                console.error('Error fetching products:', error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchProductsByCategory();
        }
    }, [id]);


    const handleAddToCart = async (productId, quantity = 1) => {
        setIsLoading(true);

        try {
            // Make sure this matches your cookie name
            if (!userId) {
                toast.error(
                    "Please log in to add items to cart"
                );
                navigate("/log-in");
                return;
            }

            // Prepare form data
            const formData = new FormData();
            formData.append("user_id", userId);
            formData.append("product_id", productId.toString());
            formData.append("quantity", quantity.toString());

            // Make API call
            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_addtocart.php", {
                method: "POST",
                body: formData,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();

            // Handle successful response
            if (result.success || result.status === "success") {
                await updateCartCount();
                toast.success("Product Added  successfully!");
            } else {
                throw new Error(result.message || "Failed to add product to cart");
            }
        } catch (error) {
            console.error("Error adding to cart:", error);
            toast.error(

                "Failed to add product to cart");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="product-cards-wrapper">
            <div className="container-fluid" style={{ marginTop: "90px" }}>
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h2 className="text-center mb-5" style={{ fontWeight: "700", color: "#1f2937" }}>
                            Our Products
                        </h2>
                    </div>
                </div>

                <div className="row justify-content-center g-4 ms-5 me-5">
                    {products.map((product) => (
                        <div key={product.id} className="col-12 col-md-6 col-lg-3">
                            <div
                                className="card h-100"
                                style={{
                                    border: "none",
                                    borderRadius: "20px",
                                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-5px)";
                                    e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.1)";
                                }}
                            >
                                {/* Product Image */}
                                <div className="card-img-top" style={{ padding: "20px 20px 0 20px" }}>
                                    <img
                                        src={product.image_gallery[0] || "/placeholder.svg"}
                                        alt={product.name}
                                        className="img-fluid"
                                        style={{
                                            width: "100%",
                                            height: "200px",
                                            objectFit: "cover",
                                            borderRadius: "15px",
                                            backgroundColor: "#f8f9fa",
                                        }}
                                    />
                                </div>

                                {/* Card Body */}
                                <div className="card-body d-flex flex-column" style={{ padding: "20px" }}>
                                    {/* Product Name */}
                                    <h5
                                        className="card-title mb-2"
                                        style={{
                                            fontWeight: "700",
                                            fontSize: "1.5rem",
                                            color: "#1f2937",
                                            lineHeight: "1.2",
                                        }}
                                    >
                                        {product.product_name}
                                    </h5>

                                    {/* Product Description */}
                                    <p
                                        className="card-text mb-3"
                                        style={{
                                            color: "#6b7280",
                                            fontSize: "1rem",
                                            lineHeight: "1.5",
                                            flexGrow: "1",
                                        }}
                                    >
                                        {product.short_description}
                                    </p>

                                    {/* Product Price */}
                                    {/* <div className="mb-3">
                                        <span
                                            style={{
                                                fontSize: "2rem",
                                                fontWeight: "700",
                                                color: "#4C4DA4",
                                                lineHeight: "1",
                                            }}
                                        >
                                            ${product.price}
                                        </span>
                                    </div> */}

                                    {/* Add to Cart Button */}
                                    {/* {userId ? (
                                        <button
                                            className="btn-signin rounded-3 full-width" onClick={() => handleAddToCart(product.id)}

                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                e.currentTarget.style.boxShadow = "0 8px 20px rgba(99, 102, 241, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "none";
                                            }}
                                        >
                                            Add to Cart
                                        </button>
                                    ) : null} */}
                                    <button
                                        className="btn-signin rounded-3 full-width mt-2" onClick={() => navigate(`/product-details/${product.id}`)}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow = "0 8px 20px rgba(99, 102, 241, 0.4)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "none";
                                        }}
                                    >
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Additional Product Cards */}

            </div>
        </div>
    );
}
